// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `label {
  font-size: 0.625rem;
  color: var(--cw-color-text-secondary);
  align-self: stretch;
  margin-block-end: 12px;
}
.ktHnSywh3yNvik8k7m9t {
  position: relative;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  margin-block-start: 4px;
  border: 1px solid var(--cw-color-divider-secondary);
  border-block-end-color: var(--cw-color-divider-primary);
  border-radius: 3px 3px 0 0;
}
.ktHnSywh3yNvik8k7m9t:focus-within {
  border-block-end-color: var(--cw-color-primary);
  box-shadow: 0 1px var(--cw-color-primary);
}
.ktHnSywh3yNvik8k7m9t input {
  outline: 0;
  background: transparent;
  color: var(--cw-color-text-primary);
  border: 0;
  margin: 0;
  block-size: 2rem;
  padding-inline: 8px;
  box-sizing: border-box;
  font-size: 0.75rem;
  inline-size: 100%;
}
.ktHnSywh3yNvik8k7m9t input.rFdbNZV7qdNqjv1phYWw {
  padding-inline-end: 35px;
}
.ktHnSywh3yNvik8k7m9t .h3WUDy8ZTep0hyjLeL59 {
  position: absolute;
  block-size: 24px;
  display: inline-block;
  inset-inline-start: calc(100% - 30px);
  background: initial;
  border: initial;
  padding: 0;
}
`, "",{"version":3,"sources":["webpack://./projects/core-app/src/pages/log-in/input.component.less"],"names":[],"mappings":"AAAA;EAEQ,mBAAA;EACA,qCAAA;EACA,mBAAA;EACA,sBAAA;AAAR;AALA;EASQ,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,qBAAA;EACA,2BAAA;EACA,mBAAA;EACA,uBAAA;EACA,mDAAA;EACA,uDAAA;EACA,0BAAA;AADR;AAGQ;EACI,+CAAA;EACA,yCAAA;AADZ;AAtBA;EA2BY,UAAA;EACA,uBAAA;EACA,mCAAA;EACA,SAAA;EACA,SAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;EACA,iBAAA;AAFZ;AAIY;EACI,wBAAA;AAFhB;AArCA;EA4CY,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,qCAAA;EACA,mBAAA;EACA,eAAA;EACA,UAAA;AAJZ","sourcesContent":[":local {\n    label {\n        font-size: .625rem;\n        color: var(--cw-color-text-secondary);\n        align-self: stretch;\n        margin-block-end: 12px;\n    }\n\n    .inputWrapper {\n        position: relative;\n        display: flex;\n        flex-direction: row;\n        flex-wrap: nowrap;\n        align-content: center;\n        justify-content: flex-start;\n        align-items: center;\n        margin-block-start: 4px;\n        border: 1px solid var(--cw-color-divider-secondary);\n        border-block-end-color: var(--cw-color-divider-primary);\n        border-radius: 3px 3px 0 0;\n\n        &:focus-within {\n            border-block-end-color: var(--cw-color-primary);\n            box-shadow: 0 1px var(--cw-color-primary);\n        }\n\n        input {\n            outline: 0;\n            background: transparent;\n            color: var(--cw-color-text-primary);\n            border: 0;\n            margin: 0;\n            block-size: 2rem;\n            padding-inline: 8px;\n            box-sizing: border-box;\n            font-size: .75rem;\n            inline-size: 100%;\n\n            &.passwordInput {\n                padding-inline-end: 35px;\n            }\n        }\n\n        .showPassword {\n            position: absolute;\n            block-size: 24px;\n            display: inline-block;\n            inset-inline-start: calc(100% - 30px);\n            background: initial;\n            border: initial;\n            padding: 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inputWrapper": `ktHnSywh3yNvik8k7m9t`,
	"passwordInput": `rFdbNZV7qdNqjv1phYWw`,
	"showPassword": `h3WUDy8ZTep0hyjLeL59`
};
export default ___CSS_LOADER_EXPORT___;
